export enum FinishReasonEnum {
    "stop" = "stop",
    "length" = "length",
}